import { render } from "./stafflist.vue?vue&type=template&id=0f67cd02"
import script from "./stafflist.vue?vue&type=script&lang=js"
export * from "./stafflist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__